<div class="d-flex">
  <div class="header-btn-lg pe-0">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left">
          <div class="btn-group" ngbDropdown placement="bottom-right">
            <button type="button" class="btn btn-link p-0 me-2"
              ngbDropdownToggle>
              <style>
    [ngbDropdownToggle]::after {
      display: none !important;
    }
  </style>
              <div
                class="icon-wrapper icon-wrapper-alt rounded-circle"
                style="width: 42px; height: 42px; overflow: hidden;">
                <img
                  [src]="profile_image"
                  alt="Profile Image"
                  class="rounded-circle"
                  style="width: 100%; height: 100%; object-fit: cover;">
              </div>
            </button>

            <div ngbDropdownMenu>
              <button class="dropdown-item"
                [routerLink]="['/users-profiles']"
                (click)="closeMobileHeader()">User Profiles</button>
              <button class="dropdown-item" (click)="logout()">Log out</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
